import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {plainToClass, plainToClassFromExist} from "class-transformer";
import {ResultListApiModel} from "../models/result-list.api.model";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {QueryParamsApiModel} from "../models/query-params-api.model";
import {QueryParamsService} from "../../core/services/query-params.service";
import {CostApiModel} from "../models/cost.api.model";

@Injectable({
  providedIn: 'root'
})
export class CostRestService {
  private readonly resource: string = '/costs';

  constructor(
    private http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  public create(costAM: CostApiModel): Observable<CostApiModel> {
    return this.http.post<CostApiModel>(environment.apiUrl + this.resource, costAM)
      .pipe(map((result: CostApiModel) => plainToClass(CostApiModel, result)));
  }

  public put(costAM: CostApiModel): Observable<CostApiModel> {
    return this.http.put<CostApiModel>(environment.apiUrl + costAM['@id'], costAM)
      .pipe(map((result: CostApiModel) => plainToClass(CostApiModel, result)));
  }

  public get(costAM: CostApiModel): Observable<CostApiModel> {
    return this.http.get<CostApiModel>(environment.apiUrl + costAM['@id'])
      .pipe(map((result: CostApiModel) => plainToClass(CostApiModel, result)));
  }

  public delete(costAM: CostApiModel): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(environment.apiUrl + costAM['@id']);
  }

  public getCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<ResultListApiModel<CostApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<CostApiModel>>(environment.apiUrl + this.resource, {params})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<CostApiModel>(CostApiModel), result as object)));
  }

  public getSubResourceCollection(ownerResource: string): Observable<ResultListApiModel<CostApiModel>> {
    return this.http.get<ResultListApiModel<CostApiModel>>(environment.apiUrl + ownerResource + this.resource)
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<CostApiModel>(CostApiModel), result as object)));
  }
}
